import { render, staticRenderFns } from "./philosophies-create.vue?vue&type=template&id=4e9ce854&"
import script from "./philosophies-create.vue?vue&type=script&lang=js&"
export * from "./philosophies-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports